module.exports = __webpack_public_path__ + "catalog/items/firesafety/exit-left/exit-left.svg";